import React from 'react';

const MediaService = (props: React.PropsWithChildren<React.SVGProps<SVGSVGElement>>) => (
  <svg
    {...props}
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    role="img"
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.809 28.125L24.834 40.6125C25.2291 41.6004 25.2167 42.7046 24.7995 43.6833C24.3823 44.6621 23.5943 45.4357 22.608 45.8347V45.8347C21.6195 46.2313 20.514 46.2195 19.5343 45.8019C18.5545 45.3843 17.7804 44.595 17.382 43.6073L11.1 28.125"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="square"
    />
    <path
      d="M22.875 10.125H10.875C8.48805 10.125 6.19887 11.0732 4.51104 12.761C2.82321 14.4489 1.875 16.7381 1.875 19.125V19.125C1.875 21.5119 2.82321 23.8011 4.51104 25.489C6.19887 27.1768 8.48805 28.125 10.875 28.125H22.875L39.375 35.625V2.625L22.875 10.125Z"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="square"
    />
    <path
      d="M43.125 15.375C44.1196 15.375 45.0734 15.7701 45.7767 16.4733C46.4799 17.1766 46.875 18.1304 46.875 19.125C46.875 20.1196 46.4799 21.0734 45.7767 21.7767C45.0734 22.4799 44.1196 22.875 43.125 22.875"
      fill="#FB6121"
      stroke="#FB6121"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
  </svg>
);

export default MediaService;
